@if (service.notificacoes$ | async; as notificacoes) {
  <div>
    @if (notificacoes?.length == 0) {
      <button type="button" aria-label="Toggle sidenav" mat-icon-button>
        <mat-icon aria-label="Side nav toggle icon ">notifications</mat-icon>
      </button>
    }
    @if (notificacoes.length > 0) {
      <button type="button" aria-label="Toggle sidenav" mat-icon-button
        [matMenuTriggerFor]="notificacao">
        <mat-icon aria-label="Side nav toggle icon " matBadge="{{notificacoes.length}}"
        matBadgeColor="warn">notifications</mat-icon>
      </button>
    }
    <mat-menu #notificacao="matMenu" style="display: flex; flex-direction: column;">
      <div mat-menu-item style="font-size: 0.9em; font-weight: 700; text-align: center;">
        <p>Notificações</p>
      </div>
      @for (item of notificacoes; track item) {
        <div mat-menu-item class="itens-menu-notificacao">
          <div (click)="service.navegarPara(item.tipo)">
            {{item.mensagem}}
          </div>
          <i class="bi bi-x" (click)="service.remover(item.tipo)"></i>
        </div>
      }
    </mat-menu>
  </div>
}
